import React from "react";
import { Link } from "react-router-dom";
import styles from "./TidePostPolicy.module.css";
import { Container } from "../components/common/Container";

// Icon components
const ShieldIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
  </svg>
);

const EyeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </svg>
);

const CircleStackIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
  </svg>
);

const CloudIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15a4.5 4.5 0 0 0 4.5 4.5H18a3.75 3.75 0 0 0 1.332-7.257 3 3 0 0 0-3.758-3.848 5.25 5.25 0 0 0-10.233 2.33A4.502 4.502 0 0 0 2.25 15Z" />
  </svg>
);

const GlobeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-.778.099-1.533.284-2.253" />
  </svg>
);

const BellIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
  </svg>
);

const ShareIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z" />
  </svg>
);

const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
  </svg>
);

const TrashIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
  </svg>
);

const LockIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
  </svg>
);

const ScaleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0 0 12 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 0 1-2.031.352 5.988 5.988 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971Zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 0 1-2.031.352 5.989 5.989 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971Z" />
  </svg>
);

const DocumentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
  </svg>
);

const EnvelopeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
  </svg>
);

const ArrowLeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
  </svg>
);

const ListIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
  </svg>
);

const CheckCircleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
  </svg>
);

interface SectionProps {
  id: string;
  number: string;
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}

const Section: React.FC<SectionProps> = ({ id, number, title, icon, children }) => (
  <section id={id} className={styles.section}>
    <div className={styles.sectionHeader}>
      <div className={styles.sectionIcon}>{icon}</div>
      <div className={styles.sectionTitleWrapper}>
        <div className={styles.sectionNumber}>Section {number}</div>
        <h2 className={styles.sectionTitle}>{title}</h2>
      </div>
    </div>
    <div className={styles.sectionBody}>{children}</div>
  </section>
);

interface ListItemProps {
  children: React.ReactNode;
}

const ListItem: React.FC<ListItemProps> = ({ children }) => (
  <li className={styles.listItem}>
    <span className={styles.listBullet} />
    <span>{children}</span>
  </li>
);

const sections = [
  { id: "overview", title: "Overview" },
  { id: "data-collection", title: "Data Collection" },
  { id: "data-storage", title: "Data Storage" },
  { id: "network-requests", title: "Network Requests" },
  { id: "notifications", title: "Push Notifications" },
  { id: "data-sharing", title: "Data Sharing" },
  { id: "children", title: "Children's Privacy" },
  { id: "data-deletion", title: "Data Deletion" },
  { id: "data-security", title: "Data Security" },
  { id: "your-rights", title: "Your Rights" },
  { id: "changes", title: "Changes to This Policy" },
  { id: "contact", title: "Contact Us" },
];

export const TidePostPolicy: React.FC = () => {
  return (
    <main id="main-content" className={styles.page} role="main" tabIndex={-1}>
      <Container maxWidth="md">
        <Link to="/tide-post" className={styles.backLink}>
          <ArrowLeftIcon />
          Back to Tide Post
        </Link>

        <header className={styles.header}>
          <div className={styles.iconWrapper}>
            <ShieldIcon />
          </div>
          <h1 className={styles.title}>Privacy Policy</h1>
          <p className={styles.subtitle}>Tide Post App</p>
          <div className={styles.meta}>
            <span>Last Updated: February 27, 2026</span>
            <span className={styles.metaDot} />
            <span>iOS Application</span>
          </div>
        </header>

        <nav className={styles.toc} aria-label="Table of Contents">
          <h2 className={styles.tocTitle}>
            <ListIcon />
            Table of Contents
          </h2>
          <ul className={styles.tocList}>
            {sections.map((section, index) => (
              <li key={section.id} className={styles.tocItem}>
                <a href={`#${section.id}`} className={styles.tocLink}>
                  <span className={styles.tocNumber}>{String(index + 1).padStart(2, "0")}</span>
                  {section.title}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className={styles.content}>
          <Section id="overview" number="01" title="Overview" icon={<EyeIcon />}>
            <p>
              This privacy policy applies to the Tide Post mobile application
              for iOS (hereby referred to as "the App"). This policy outlines
              our practices regarding data collection, use, and sharing. This
              privacy policy is consistent with the data practices disclosed in
              the App Store privacy labels.
            </p>
            <p>
              Tide Post is designed with privacy as a core principle. The App
              does not require an account, does not collect personal information,
              and does not use any analytics or tracking services.
            </p>
          </Section>

          <Section id="data-collection" number="02" title="Data Collection" icon={<CircleStackIcon />}>
            <div className={styles.notice}>
              <div className={styles.noticeIcon}>
                <CheckCircleIcon />
              </div>
              <p><strong>We do not collect any personal data.</strong> Tide Post does not
              require you to create an account, sign in, or provide any personal
              information. We do not collect your name, email address, phone number,
              or any other identifying information.</p>
            </div>
            <p>
              The only data the App stores is your preferences and settings, which
              are kept entirely on your device:
            </p>
            <ul className={styles.list}>
              <ListItem>Selected tidal station</ListItem>
              <ListItem>Favorite stations list</ListItem>
              <ListItem>Unit preference (Imperial or Metric)</ListItem>
              <ListItem>Tide alert notification settings</ListItem>
            </ul>
          </Section>

          <Section id="data-storage" number="03" title="Data Storage" icon={<CloudIcon />}>
            <p>
              All user data is stored locally on your device using iOS native
              storage. This includes:
            </p>
            <ul className={styles.list}>
              <ListItem>Your selected station and favorite stations</ListItem>
              <ListItem>Unit system preference (feet or meters)</ListItem>
              <ListItem>Notification preferences and alert configuration</ListItem>
            </ul>
            <div className={styles.infoCard}>
              <p>
                No data is stored on external servers. We do not operate any
                backend servers or cloud databases for this App.
              </p>
            </div>
          </Section>

          <Section id="network-requests" number="04" title="Network Requests" icon={<GlobeIcon />}>
            <p>
              The App makes network requests solely to the NOAA (National Oceanic
              and Atmospheric Administration) Tides & Currents public API to
              retrieve:
            </p>
            <ul className={styles.list}>
              <ListItem>Real-time water level measurements</ListItem>
              <ListItem>Tide predictions (high/low times and heights)</ListItem>
              <ListItem>Tidal station metadata (name, location, ID)</ListItem>
            </ul>
            <p>
              These requests are made to{" "}
              <code className={styles.code}>https://api.tidesandcurrents.noaa.gov</code>{" "}
              and do not include any personal information. Only the station ID, date
              range, and data format parameters are sent. See the{" "}
              <a
                href="https://www.noaa.gov/protecting-your-privacy"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                NOAA Privacy Policy
              </a>
              .
            </p>
          </Section>

          <Section id="notifications" number="05" title="Push Notifications" icon={<BellIcon />}>
            <p>
              The App can send push notifications for tide alerts. This feature:
            </p>
            <ul className={styles.list}>
              <ListItem>Requires your explicit permission</ListItem>
              <ListItem>Is entirely optional and can be disabled anytime</ListItem>
              <ListItem>Is processed locally on your device</ListItem>
              <ListItem>
                Does not send your data to external servers (notifications are
                scheduled locally using iOS APIs)
              </ListItem>
            </ul>
            <p>
              You can configure notifications to alert you 30 minutes, 1 hour, or
              2 hours before high tides, low tides, or both.
            </p>
          </Section>

          <Section id="data-sharing" number="06" title="Data Sharing" icon={<ShareIcon />}>
            <div className={styles.notice}>
              <div className={styles.noticeIcon}>
                <CheckCircleIcon />
              </div>
              <p><strong>We do not share any data.</strong> Since we do not collect any
              personal data, there is nothing to share.</p>
            </div>
            <p>Specifically:</p>
            <ul className={styles.list}>
              <ListItem>We do not sell data to third parties</ListItem>
              <ListItem>We do not use advertising SDKs</ListItem>
              <ListItem>We do not use analytics or tracking services</ListItem>
              <ListItem>We do not use any third-party SDKs that collect user data</ListItem>
            </ul>
            <p>
              The only external service the App communicates with is the public NOAA
              API, which is a U.S. government service.
            </p>
          </Section>

          <Section id="children" number="07" title="Children's Privacy" icon={<UsersIcon />}>
            <p>
              The App is suitable for all ages. Since no personal information is
              collected from any user, Tide Post is safe for children to use. No
              special age restrictions apply.
            </p>
          </Section>

          <Section id="data-deletion" number="08" title="Data Deletion" icon={<TrashIcon />}>
            <p>
              To delete all data stored by the App, simply uninstall Tide Post
              from your device. Since all data is stored locally and no data is
              stored on external servers, uninstalling the App completely removes
              all associated data.
            </p>
          </Section>

          <Section id="data-security" number="09" title="Data Security" icon={<LockIcon />}>
            <p>Your data is protected through:</p>
            <ul className={styles.list}>
              <ListItem>
                <strong>Local security</strong> - iOS built-in security features,
                including device passcode and biometric authentication
              </ListItem>
              <ListItem>
                <strong>No external transmission</strong> - Your preferences and
                settings never leave your device
              </ListItem>
              <ListItem>
                <strong>Encrypted connections</strong> - All requests to the NOAA
                API use HTTPS/TLS encryption
              </ListItem>
              <ListItem>
                <strong>No sensitive data</strong> - The App does not handle
                passwords, payment information, or other sensitive data
              </ListItem>
            </ul>
          </Section>

          <Section id="your-rights" number="10" title="Your Rights" icon={<ScaleIcon />}>
            <p>You have the right to:</p>
            <ul className={styles.list}>
              <ListItem>Access your data (visible within the App settings)</ListItem>
              <ListItem>Delete your data (uninstall the App)</ListItem>
              <ListItem>Disable push notifications (in iOS Settings)</ListItem>
              <ListItem>Control location access (the App does not request location permissions)</ListItem>
            </ul>
          </Section>

          <Section id="changes" number="11" title="Changes to This Policy" icon={<DocumentIcon />}>
            <p>
              We may update this privacy policy from time to time. Any changes
              will be reflected in the App and on this page. We will update the
              "Last Updated" date at the top of this policy when changes are made.
            </p>
          </Section>

          <Section id="contact" number="12" title="Contact Us" icon={<EnvelopeIcon />}>
            <p>
              If you have any questions or concerns about this privacy policy or
              the App, please contact us at:
            </p>
            <div className={styles.contactCard}>
              <div className={styles.contactIcon}>
                <EnvelopeIcon />
              </div>
              <div className={styles.contactDetails}>
                <p className={styles.contactLabel}>Email</p>
                <a
                  href="mailto:dixonappdevelopment@gmail.com"
                  className={styles.contactEmail}
                >
                  dixonappdevelopment@gmail.com
                </a>
              </div>
            </div>
          </Section>
        </div>
      </Container>
    </main>
  );
};
